<template>
  <auth>
    <div
      v-if="is_loaded"
      class="auth"
    >
      <h4>Reset Password</h4>
      <hr>
      <div v-html="$error.handle(error)" />
      <form
        v-if="is_valid"
        @submit.prevent="submit"
      >
        <div class="form-group">
          <label>New Password</label>
          <input
            v-model="password.password"
            type="password"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <label>Confirm New Password</label>
          <input
            v-model="password.password_confirmation"
            type="password"
            class="form-control"
          >
        </div>
        <div class="form-group">
          <button class="btn btn-primary">
            Set New Password
          </button>
        </div>
      </form>
      <div
        v-else
        class="alert alert-danger"
      >
        <p>Your account could not be found. Plese contact support.</p>
      </div>
      <br>
    </div>
    <loading v-else />
  </auth>
</template>

<script>
    import Auth from "@/components/Auth.vue";

    export default {
        components: {
            Auth
        },

        data() {
            return {
                password: {
                    code: this.$route.params.code,
                    password: '',
                    password_confirmation: '',
                },
                is_valid: false,
                is_loaded: false,
                error: ''
            }
        },

        mounted() {
            this.fetch()
        },

        methods: {
            fetch() {
                this.is_valid = true;
                this.is_loaded = true;
            },

            submit() {
                this.is_loaded = false;
                this.$axios.post('/api/password-set-new', this.password).then(() => {
                    this.is_loaded = true;
                    this.$toastr.s('Your password has been updated', '');
                    this.$router.push({name: 'login'});
                }).catch(error => {
                    if (error.response) {
                        this.error = error.response;
                    }
                    this.is_loaded = true;
                })
            }
        }
    }
</script>

<style type="text/css">
    .alert-warning p {
        color: #fd0d39;
    }
</style>
